// extracted by mini-css-extract-plugin
module.exports = {"slide":"style-module--slide--1ALfv","arrow":"style-module--arrow--3rqGZ","carousel":"style-module--carousel--27qSK","slider":"style-module--slider--2CaKg"};